/* eslint-disable no-unused-vars */
import Link from 'next/link'

import ContactNumber from './ContactNumber'

import s from './Header.module.scss'

type HeaderActionIconsProps = {
  userData: any
  isTablet: boolean
  isMounted: boolean
}

export default function HeaderActionIcons({
  userData,
  isTablet,
  isMounted,
}: HeaderActionIconsProps) {
  if (isTablet || !isMounted) return null

  return (
    <div className={s.actionIcons}>
      {userData?.type === 'Customer' || !userData ? (
        <Link href="/puppy-financing" className={s.financing}>
          <img
            src="/financings/wallet.svg"
            alt="Wallet"
            width={40}
            height={40}
          />
          Financing Available
        </Link>
      ) : null}

      <ContactNumber isMounted={isMounted} />
    </div>
  )
}
